"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useActionOutsideElement = void 0;
var React = __importStar(require("react"));
/**
 * Given an HTMLElement ref, returns true to the callback when the user clicks/touches outside of, or blurs, the HTMLElement
 * @param ref React.RefObject<HTMLElement>
 * @param callback (isOutsideElement: boolean) => void
 */
var useActionOutsideElement = function (ref, callback) {
    var container = ref.current;
    var closeIfOutsideComponent = function (target) {
        return callback((container && !container.contains(target)) || false);
    };
    var onClickOutside = function (event) {
        if (event.target) {
            closeIfOutsideComponent(event.target);
        }
    };
    var onTouchend = function (event) {
        if (event.changedTouches && event.changedTouches[0]) {
            closeIfOutsideComponent(event.changedTouches[0].target);
        }
    };
    var onBlur = function (event) {
        if (event.relatedTarget) {
            closeIfOutsideComponent(event.relatedTarget);
        }
    };
    React.useEffect(function () {
        document.addEventListener("mousedown", onClickOutside);
        document.addEventListener("touchend", onTouchend);
        if (container) {
            container.addEventListener("focusout", onBlur);
        }
        return function () {
            document.removeEventListener("mousedown", onClickOutside);
            document.removeEventListener("touchend", onTouchend);
            if (container) {
                container.removeEventListener("focusout", onBlur);
            }
        };
    });
};
exports.useActionOutsideElement = useActionOutsideElement;
